var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6689 14.5547V15.4624M16.6689 19.0926V20.0003M14.3086 15.9162L15.0922 16.3701M18.2457 18.1848L19.0292 18.6386M14.3086 18.6386L15.0922 18.1848M18.2457 16.3697L19.0292 15.9158M17.9508 15.9929C18.6598 16.702 18.6598 17.852 17.9508 18.5611C17.2417 19.2692 16.0925 19.2692 15.3844 18.5611C14.6753 17.852 14.6753 16.702 15.3844 15.9929C16.0925 15.2848 17.2417 15.2848 17.9508 15.9929Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 19.2118C5.77344 17.2071 7.35507 14.7109 11.9133 14.7109",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 7.92188C7.98438 10.0875 9.73974 11.8438 11.9053 11.8438C14.0718 11.8438 15.8272 10.0875 15.8272 7.92188C15.8272 5.75626 14.0718 4 11.9053 4C10.7217 4 9.66059 4.52467 8.94167 5.35408",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user-setting.53ee972c2dd1c0ae5d88d75e30739364.svg";
export { ForwardRef as ReactComponent };